import { useGlobalStore, usePersistantStore } from "@/stores/global";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect, useState } from "react";
import { TopBar } from "@/shared/structure/TopBar";
import useRights from "@/shared/api/useRights";
import { Delete, DeleteForever, EditLocation, EditLocationAlt, LocalShipping, NotInterested, Warehouse } from "@mui/icons-material";
import DeliveryMachines from "./DeliveryMachines";
import Bauhof from "./Bauhof";

export default function MachineTransportWrap() {
  const setPageTitle = useGlobalStore((state) => state.setPageTitle);


  useEffect(() => setPageTitle("Maschinentransport"), []);
  const rights = useRights();

  const [list, setList] = useState<"DELIVERY" | "TAKEAWAY">("DELIVERY");
  const [settings, setSettings] = useState(["STORNO","LOCATIONMENU"]);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          p: 0,
          background: "#eee",
        }}
      >
        <TopBar>
          <ToggleButtonGroup
            size="small"
            orientation="horizontal"
            exclusive
            value={list}
            onChange={(_, type) => type && setList(type)}
          >
            <ToggleButton value="DELIVERY">
              <LocalShipping sx={{mr: 1}} /> Transportgeräte
            </ToggleButton>
            <ToggleButton value="TAKEAWAY">
              <Warehouse sx={{mr: 1}} /> Abholgeräte
            </ToggleButton>
          </ToggleButtonGroup>
          {list === "DELIVERY" ? <ToggleButtonGroup
            size="small"
            orientation="horizontal"
            value={settings}
            color="primary"
            onChange={(_, settings) => setSettings(settings)}
          >
            <ToggleButton value="NOT_NEEDED">
              <NotInterested  />
            </ToggleButton>
            <ToggleButton value="STORNO">
              <DeleteForever />
            </ToggleButton>
            <ToggleButton value="LOCATIONMENU">
              <EditLocationAlt />
            </ToggleButton>
          </ToggleButtonGroup>
          : null}
        </TopBar>
        {list === "DELIVERY" ? <DeliveryMachines visible={settings.concat(["NEW","SEEN","ACCEPTED","MOVED"])} /> : <Bauhof />}
      </Box>
    </Box>
  );
}
